import Vue from 'vue';
import { keyBy } from 'lodash';
import types from './mutation-types';


const mutations = {
  [types.SET_PAGE_LIBRARY_FILTER](state, { property, value }) {
    Vue.set(state.pageLibraryFilters, property, value);
  },

  [types.SET_MY_CARDS_FILTER](state, { property, value }) {
    Vue.set(state.myCardsFilters, property, value);
  },

  [types.SET_LIBRARY_FILTER](state, { property, value }) {
    Vue.set(state.libraryFilters, property, value);
  },

  [types.SET_ASSIGNMENTS_FILTER](state, { property, value }) {
    Vue.set(state.assignmentsFilters, property, value);
  },

  [types.SET_CORE_CONCEPTS](state, coreConceptList) {
    Vue.set(state, 'coreConcepts', keyBy(coreConceptList, coreConcept => coreConcept.id));
  },

  [types.SET_DOMAINS](state, domainList) {
    Vue.set(state, 'domains', {
      ...state.domains,
      ...keyBy(domainList, domain => domain.id),
    });
  },

  [types.SET_UNITS](state, unitList) {
    Vue.set(state, 'units', keyBy(unitList, unit => unit.id));
  },

  [types.SET_SUBJECTS](state, subjectList) {
    Vue.set(state, 'subjectList', subjectList);
    Vue.set(state, 'subjectMap', {
      ...state.subjectMap,
      ...keyBy(subjectList, 'id'),
    });
  },

  [types.SET_GRADES](state, gradeList) {
    Vue.set(state, 'gradeMap', {
      ...state.gradeMap,
      ...keyBy(gradeList, 'id'),
    });
  },

  [types.FETCH_GRADE_SUBJECTS](state, gradeSubjects) {
    Vue.set(state, 'gradeSubjects', gradeSubjects);
  },

  [types.RESET_GRADE_SUBJECTS](state) {
    Vue.set(state, 'gradeSubjects', []);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/browse-filters/store/mutations.js